import styled from 'styled-components';

const WidgetContent = styled.div`
    padding: 1rem;
`;

export default WidgetContent;
